export const MEET_GET_STATUS = 'MEET_GET_STATUS';
export const MEET_START = 'MEET_START';
export const MEET_SHOW_WEBINAR_REG = 'MEET_SHOW_WEBINAR_REG';
export const MEET_WEBINAR_REG_FORM_FIELD_CHANGED = 'MEET_WEBINAR_REG_FORM_FIELD_CHANGED';
export const MEET_WEBINAR_REG = 'MEET_WEBINAR_REG';
